import { useParams } from "react-router-dom";
import CheckInContent from "./CheckInContent";

const CheckInPage = () => {
    const { id } = useParams();
    if (!id) return null;
    return <CheckInContent reservationId={id} />;
};

export default CheckInPage;
